import { CdkAccordionModule } from '@angular/cdk/accordion';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { BannerComponent, HideDownloadDirective } from '@cargos/sprintpay-ui';
import { BannerComponent as appBannerComponent } from '../../components/banner/banner.component';
import { ImageLoaderComponent } from '../../components/image-loader/image-loader.component';
import { ConfirmationMaterialModule } from './confirmation-material-modules.module';
import { ConfirmationComponent } from './confirmation.component';

@NgModule({
    imports: [
        CommonModule,
        NgOptimizedImage,
        BannerComponent,
        ImageLoaderComponent,
        ConfirmationMaterialModule,
        CdkAccordionModule,
        appBannerComponent,
        HideDownloadDirective,
    ],
    declarations: [ConfirmationComponent],
    exports: [ConfirmationComponent],
})
export class ConfirmationModule {}
